"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      colors = _useTheme.colors,
      fonts = _useTheme.fonts;

  var _usePalette = (0, _usePalette2.default)(),
      typography = _usePalette.typography;

  var label = typography.label;
  return {
    root: _objectSpread({}, fonts.label, {
      color: colors[label]
    })
  };
};

__signature__(useStyles, "useTheme{{ colors, fonts }}\nusePalette{{ typography }}", function () {
  return [_useTheme2.default, _usePalette2.default];
});

var Label = function Label(props) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'span' : _props$as,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'label' : _props$variant,
      inactive = props.inactive,
      other = (0, _objectWithoutProperties2.default)(props, ["as", "variant", "inactive"]);
  var classes = useStyles();
  return (0, _core.jsx)(Element, (0, _extends2.default)({
    css: classes.root
  }, other));
};

__signature__(Label, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Label;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Label.tsx");
  reactHotLoader.register(Label, "Label", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Label.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Label.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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